"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames, responsiveClassNames, responsivePropDependency } from "../../utilities/props.js";
import HiddenInput from "../_private/HiddenInput/index.js";
import Text from "../Text/index.js";
import { useRadioGroup } from "../RadioGroup/index.js";
import { useFormControl } from "../FormControl/index.js";
import s from "./Radio.module.css";
const Radio = (props) => {
    const { children, value, onChange, onFocus, onBlur, size = "medium", className, attributes, inputAttributes, } = props;
    const formControl = useFormControl();
    const radioGroup = useRadioGroup();
    const hasError = formControl?.hasError || props.hasError || radioGroup?.hasError;
    const disabled = formControl?.disabled || props.disabled || radioGroup?.disabled;
    const checked = radioGroup ? radioGroup.value === value : props.checked;
    const defaultChecked = radioGroup ? undefined : props.defaultChecked;
    const name = radioGroup ? radioGroup.name : props.name;
    const rootClassName = classNames(s.root, className, hasError && s["--error"], disabled && s["--disabled"], size && responsiveClassNames(s, "--size", size));
    const handleChange = (event) => {
        if (!name)
            return;
        const { checked } = event.target;
        const changeArgs = { name, value, checked, event };
        if (onChange)
            onChange(changeArgs);
        if (radioGroup?.onChange)
            radioGroup.onChange(changeArgs);
    };
    return (_jsxs("label", { ...attributes, className: rootClassName, children: [_jsxs("span", { className: s.field, children: [_jsx(HiddenInput, { className: s.input, type: "radio", checked: checked, defaultChecked: defaultChecked, name: name, disabled: disabled, value: value, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, attributes: inputAttributes }), _jsx("div", { className: s.decorator })] }), children && (_jsx(Text, { as: "span", variant: responsivePropDependency(size, (size) => {
                    if (size === "large")
                        return "body-2";
                    if (size === "small")
                        return "caption-1";
                    return "body-3";
                }), children: children }))] }));
};
Radio.displayName = "Radio";
export default Radio;
